import TwoColumnLayout from "layout/TwoColumnLayout";
import { useLoaderData } from "react-router";
import React from "react";
import { FlightDetailSection } from "flights/FlightDetailSection";
import FlightOptionsPanel from "flights/FlightOptionsPanel";
import { FlightActivityPanel } from "./activity/FlightActivityPanel";
import { FlightItinerarySidebarApp } from "show/ItinerarySidebar/app";
import moment from "moment";

export const FlightDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FlightDetailFrontModel>();
  const [artist, setArtist] = React.useState<server.dto.ArtistSmall>(viewModel.sidePanelDto.flight.artist);
  const [appointmentDateTime, setAppointmentDateTime] = React.useState<server.dto.AppointmentDateTime>({
    startDisplay: viewModel.sidePanelDto.flight.departureLocal,
    endDisplay: viewModel.sidePanelDto.flight.arrivalLocal,
    mode: "allDay",
    customFallbackTime: "",
  });
  const [linkedShows, setLinkedShows] = React.useState<server.dto.LinkedShow[]>(viewModel.sidePanelDto.linkedShows);
  const [queryKey, setQueryKey] = React.useState<number>(0);

  const refetchLinkedShows = async () => {
    const result = await window.CoreApi.Flight.GetSidePanelData(viewModel.sidePanelDto.flight.flightId);
    if (result.data.hasErrors) {
      return;
    }
    setLinkedShows(result.data.data.linkedShows);
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FlightDetailSection
        refetchLinkedShows={refetchLinkedShows}
        flight={viewModel.sidePanelDto.flight}
        linkedShows={linkedShows}
        passengers={viewModel.sidePanelDto.passengers}
        onArtistChanged={a => setArtist(a)}
        onStatusChanged={() => setQueryKey(prev => prev + 1)}
        onAirportChanged={() => setQueryKey(prev => prev + 1)}
        onDateChanged={d => {
          setAppointmentDateTime(d);
          setQueryKey(prev => prev + 1);
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <FlightOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        flightId={viewModel.sidePanelDto.flight.flightId}
      />
      {site.currentEnvironment.type === "internal" && <FlightItinerarySidebarApp
        flightId={viewModel.sidePanelDto.flight.flightId}
        artist={artist}
        startDate={moment.utc(appointmentDateTime.startDisplay)}
        endDate={moment.utc(appointmentDateTime.endDisplay)}
        linkedShowIds={linkedShows.map(ls => ls.showId)}
        onLinkUnlinkShow={refetchLinkedShows}
        queryKeys={`flightItinerary-${queryKey}`}
      />}
      {site.currentEnvironment.type === "internal" && <FlightActivityPanel
        config={viewModel.activityPanelConfig}
        flightId={viewModel.sidePanelDto.flight.flightId}
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}